"use strict";

/** 
* Базовый объект с поддержкой событий.
*
* @class BaseObject
* @abstract
* @property {string} className Имя класса
* @property {Class} class Ссылка на интерфейс класса для упрощённого доступа к статическим свойствам (например, EVENT).
* @param {any} Данные
*/
var BaseObject = Class.extend({

  init: function (data) {
    if (!this._events) {
      this._events = [];
    }
    this.fire(BaseObject.EVENT.CLASS_INIT, this);
  },

  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  className: "BaseObject",

  /** @private */
  _events: null,
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Пред-обработка переданных параметров
  * @method BaseObject#_parseArguments
  * @private
  * @since 5.2.0.1100
  */
  _parseArguments: function (args) {
  },
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * @private
  * @method BaseObject#_simplifyName
  */
  _simplifyName: function (name) {
    name = "" + name;
    name = name.makeSafeString().toLowerCase();
    if (name.substr(0, 2) === 'on') {
      name = name.substr(2, name.length);
    };
    return name;
  },
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /** 
  * Привязать функцию к событию.
  * @method BaseObject#bind
  * @param {string} name Имя события
  * @param {function} callback Функция, срабатывающая при событии
  * @param {object} [opt_context] Контекст исполнения
  * @return {BaseObject} Объект типа BaseObject.
  */
  bind: function (name, func, opt_context) {
    name = this._simplifyName(name);

    if (window.ENABLE_EVENTS_LOGGING) {
      //Шамов А.: Для отладки событий.
      console.log('BaseObject.bind ' + name, arguments);
    }

    if (!this._events) {
      this._events = [];
    }

    if (this._events) {
      if (!this._events[name]) {
        this._events[name] = [];
      }
      func = !!opt_context ? $.proxy(func, opt_context) : func;
      this._events[name].push(func);
    }
    return this;
  },
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /** 
  * Удалить функцию, привязанную к событию.
  *
  * @method BaseObject#unbind
  * @param {string} name Имя события
  * @return {BaseObject} Объект типа BaseObject.
  */
  unbind: function (name) {
    name = this._simplifyName(name);

    if (window.ENABLE_EVENTS_LOGGING) {
      //Шамов А.: Для отладки событий.
      console.log('BaseObject.unbind ' + name, arguments);
    }
    this._events[name] = [];
    return this;
  },
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Вызвать событие.
  *
  * @method BaseObject#fire
  * @param {string} Имя события
  * @return {boolean} Метод вернет False, если хотя бы один из обработчиков метода bind вернул False. 
  * При этом условии другие обработчики событий вызваны не будут. 
  */
  fire: function (name) {
    name = this._simplifyName(name);

    //Шамов А.: Для отладки событий.
    if (window.ENABLE_EVENTS_LOGGING) {
      if (!WA.ENV.isTouch()) {
        console.log('BaseObject.fire ' + name, arguments);
      } else {
        //Шамов А.: Почему-то провоцирует ошибки на планшетах.
        //logDebug('BaseObject.fire ' + arguments[0]);
      }
    }

    // try {
    var args = $.makeArray(arguments);
    args.splice(0, 1);
    if (this._events && this._events[name]) {
      for (var i = 0, len = this._events[name].length; i < len; i++) {
        if ($.isFunction(this._events[name][i])) {
          var r = this._events[name][i].apply(this, args);
          if (typeof r != 'undefined' && !r) {
            return false;
          }
        }
      }
      return true;
    }
    /*} catch (ex) {
      console.trace()
      log.error('BASE_OBJECT', ex);
      return false;
    }*/
  },
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /** 
  * Последовательно вызвать события BeforeEvent, Event, AfterEvent.
  *
  * @method BaseObject#fireAll
  * @param {string} eventName Имя события, переданное методу
  * @param {string} mainFunc Функция, срабатывающая при событии
  * @ignore
  */
  fireAll: function (eventName, mainFunc) {
    eventName = this._simplifyName(eventName);

    //Шамов А.: Для отладки событий.
    if (window.ENABLE_EVENTS_LOGGING) {
      if (!WA.ENV.isTouch()) {
        console.log('BaseObject.fireAll ' + eventName, arguments);
      } else {
        //Шамов А.: Почему-то провоцирует ошибки на планшетах.
        //logDebug('BaseObject.fireAll ' + eventName);
      }
    }

    var isRun = false;
    var me = this;
    var args = $.makeArray(arguments);
    args.splice(0, 2);

    // Обертка над callback с вызвовом Before и After событий.
    var mainFuncWrapper = function (result) {
      if (typeof result == 'undefined' || result) {
        mainFunc.apply(me, args);

        var newArgs = $.merge(['After' + eventName], args);
        me.fire.apply(me, newArgs);
      }
      isRun = true;
    };

    var newArgs = $.merge(['Before' + eventName, mainFuncWrapper], args);
    var r = me.fire.apply(me, newArgs);
    if (!isRun) {
      mainFuncWrapper(r);
    }
  },
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Получить строковое представление объекта.
  *
  * @method BaseObject#asString
  * @since 5.0.0.7100
  * @return {string} Строковое представление объекта.
  */
  asString: function () {
    return $.toJSON(this);
  }
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

}, {
  /**
   * Срабатывает после вызова конструктора
   *
   * @event BaseObject.EVENT.CLASS_INIT
   * @type {object}
   * @property {boolean} context - ссылка на экземпляр класса
   */
  EVENT: {
    CLASS_INIT: 'classInit'
  }
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
});